export const errorCodes = [
    "36",
    "37",
    "39",
    "47",
    "53",
    "118",
    "120",
    "121",
    "122",
    "148",
    "1"
]
